import React from 'react';
import { IconProps } from '../Icons.interface';

export const DeleteOutlineIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66699 7.33333V11.3333M9.33366 7.33333V11.3333M2.66699 4.66667H13.3337M12.667 4.66667L12.089 12.7613C12.065 13.0977 11.9145 13.4125 11.6677 13.6424C11.4209 13.8722 11.0962 14 10.759 14H5.24166C4.90442 14 4.5797 13.8722 4.33292 13.6424C4.08613 13.4125 3.9356 13.0977 3.91166 12.7613L3.33366 4.66667H12.667ZM10.0003 4.66667V2.66667C10.0003 2.48986 9.93009 2.32029 9.80506 2.19526C9.68004 2.07024 9.51047 2 9.33366 2H6.66699C6.49018 2 6.32061 2.07024 6.19559 2.19526C6.07056 2.32029 6.00033 2.48986 6.00033 2.66667V4.66667H10.0003Z"
      stroke="currentColor"
      strokeWidth="1.43434"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
